import React, { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import OvVideoDeletedSnackbar from './OvVideoDeletedSnackbar';
import { VideoLibraryLocationState } from '../../../common/model/type/video-list-filter.types';

const OvVideoLibraryDeletedNotice: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as VideoLibraryLocationState | undefined;

  return (
    <OvVideoDeletedSnackbar
      action={state?.deleted ?? null}
      onClose={() =>
        navigate(
          { pathname: location.pathname, search: location.search },
          { replace: true }
        )
      }
    />
  );
};

export default OvVideoLibraryDeletedNotice;
